import { render, staticRenderFns } from "./DeviationSearch.vue?vue&type=template&id=827215f2&scoped=true&"
import script from "./DeviationSearch.vue?vue&type=script&lang=js&"
export * from "./DeviationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827215f2",
  null
  
)

export default component.exports